// extracted by mini-css-extract-plugin
export default {"signatureUpload":"UploadSignatureInput_signatureUpload__bR7Yk"};